import { DataTableCellProps, TableCell } from 'components/dataTable';

export const DefaultCell = ({ className, row, column }: DataTableCellProps & { className?: string }) => {
  const value = row[column.id];
  return (
    <TableCell className={className} data-column={column.id}>
      {value}
    </TableCell>
  );
};
